import { Loading } from 'src/components/pages';
import { useUserReportsQuery } from 'src/graphql';
import { ReportingReportsListView } from './ReportingReportsListView';

export const ReportingReportsList = () => {
  const { data: reports, isLoading } = useUserReportsQuery();

  if (isLoading) {
    return <Loading />;
  }
  return <ReportingReportsListView reports={reports?.userReports} />;
};
